export const getErrorMessage = (error: unknown, fallback = ""): string => {
  if (error instanceof Error) {
    return error.message || fallback;
  }

  if (typeof error === "object" && error !== null) {
    if ("message" in error) {
      const message = (error as { message?: unknown }).message;
      if (typeof message === "string" && message) return message;
    }

    if ("msg" in error) {
      const msg = (error as { msg?: unknown }).msg;
      if (typeof msg === "string" && msg) return msg;
    }
  }

  return fallback;
};

export const errorUtils = { getErrorMessage };
